import React, { useEffect, useState } from 'react';
import { fetchFileByObjectID, fetchFileUrlByID } from '../../services/api';
import './fileList.css';

export default function FileList({ data_type, data_identifier, onClose }) {
  const [data, setData] = useState([]);
  const [error, setError] = useState('');

  const formatDatetime = datetime => {
    let dateObj = new Date(datetime);

    let day = String(dateObj.getDate()).padStart(2, '0');
    let month = String(dateObj.getMonth() + 1).padStart(2, '0');
    let year = dateObj.getFullYear();

    let hours = String(dateObj.getHours()).padStart(2, '0');
    let minutes = String(dateObj.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}h${minutes}`;
  };

  const getTranslatedName = document_type => {
    switch (document_type) {
      case 'invoice':
        return 'Facture';
      case 'credit':
        return 'Avoir';
      case 'proforma':
        return 'Proforma';
      case 'client_order':
        return 'PDF Client';
      case 'shipment_order':
        return 'PDF Transporteur';
      default:
        return 'Autre';
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const object_id =
          data_type === 'invoice' || data_type === 'credit'
            ? data_identifier.substring(2, 12).replace('-', '').replace('B', '2')
            : data_identifier;
        const fetchedData = await fetchFileByObjectID(object_id);
        if (fetchedData && Array.isArray(fetchedData.results)) {
          let filteredData = fetchedData.results;
          if (data_type === 'invoice' || data_type === 'credit') {
            filteredData = filteredData.filter(file => file.document_type !== 'shipment_order');
          }
          setData(filteredData);
        } else {
          setData([]);
          console.error('La réponse ne contient pas de tableau "results"');
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des données:', error);
        setData([]);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFileClick = async index => {
    const GetFileURL = async id => {
      try {
        const response = await fetchFileUrlByID(id);
        setError('');
        return response;
      } catch (error) {
        setError('Erreur de récupération du fichier depuis le serveur.');
      }
    };

    const url = await GetFileURL(data[index].id);
    window.open(url, '_blank');
  };

  return (
    <div className="overlay file-list-overlay">
      <div className="file-list-content">
        <span className="overlay-close" onClick={onClose}>
          &times;
        </span>
        <div className="file-list-header">
          <p>
            Fichiers disponibles pour{' '}
            {data_type === 'invoice'
              ? 'la facture'
              : data_type === 'credit'
                ? "l'avoir"
                : 'le dossier'}{' '}
            n°{data_identifier}
          </p>
          <p>Cliquer pour ouvrir</p>
        </div>
        <div className="file-list">
          <table>
            <thead>
              <tr>
                <th>Numéro</th>
                <th>Date</th>
                <th>Partenaire</th>
                <th>Type</th>
                {/* <th></th> */}
              </tr>
            </thead>
            <tbody>
              {data.map((file, index) => (
                <tr key={index}>
                  <td onClick={() => handleFileClick(index)}>{file.object_number}</td>
                  <td onClick={() => handleFileClick(index)}>
                    {formatDatetime(file.creation_date)}
                  </td>
                  <td onClick={() => handleFileClick(index)}>
                    {['invoice', 'credit', 'proforma', 'client_order'].includes(file.document_type)
                      ? file.client
                      : file.carrier}
                  </td>
                  <td onClick={() => handleFileClick(index)}>
                    {getTranslatedName(file.document_type)}
                  </td>
                  {/* <td>
                                        <a href={file.file} download>
                                            {<DownloadIcon style={{ color: "#003366"}}/>}
                                        </a>
                                    </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {error && <p>{error}</p>}
      </div>
    </div>
  );
}
